import {Box, Grid2} from '@mui/material';

import BannerChargeWallet from './LoadingSections/BannerChargeWallet';
import MysteryBoxesSkeleton from './LoadingSections/MysteryBoxeesSkeleton';
import {
  ChangeWalletSkeleton,
  HeaderSkeleton,
  PackagesSkeleton,
  TitleSectionSkeleton,
} from './LoadingSections';

export const StoreTemplate = () => (
  <Grid2
    spacing={1.75}
    sx={{
      p: 2,
    }}>
    <Box>
      {/* Header */}
      <HeaderSkeleton />
      {/* Charge Wallet Section */}
      <Grid2
        sx={{
          borderRadius: '10px',
          position: 'relative',
          marginTop: '30px',
        }}
        size={12}>
        <TitleSectionSkeleton />
        <ChangeWalletSkeleton />
        <BannerChargeWallet />
      </Grid2>
      {/* MysteryBoxesSkeleton */}
      <Grid2 mt={2}>
        <MysteryBoxesSkeleton />
      </Grid2>
      {/* Packages Section */}
      <Grid2 mt={2}>
        <TitleSectionSkeleton />
        <PackagesSkeleton />
      </Grid2>

      {/* Get New Avatars Section */}
      <Grid2 mt={2}>
        <TitleSectionSkeleton />
        <PackagesSkeleton />
      </Grid2>
    </Box>
  </Grid2>
);
